import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { AppProviders } from "@/app/providers";
import { router } from "@/app/router";
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import { isChunkLoadError, recoverFromChunkLoadError } from "@/shared/lib/chunkRecovery";
import "@/styles/globals.css";

window.addEventListener("error", (event) => {
  if (isChunkLoadError(event.error) || isChunkLoadError(event.message)) {
    event.preventDefault();
    recoverFromChunkLoadError();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
    recoverFromChunkLoadError();
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  </React.StrictMode>
);
